import { deleteReminder, fetchRemainder, fetchReport, updateReminder } from "../../../redux/slices/remainderSlice";
import { useApiCall } from "../../common/useApiCall"

export const useRemainderApi = () => {
    const apiCall = useApiCall();

    const createRemainder = (data, onSuccess, onError) => {
        apiCall(fetchRemainder.type, data, onSuccess, onError);
    }

    const editReminder = (data, onSuccess, onError) => {
        apiCall(updateReminder.type, data, onSuccess, onError);
    }

    const removeReminder = (data, onSuccess, onError) => {
        apiCall(deleteReminder.type, data, onSuccess, onError);
    }

    const getReminderReports = (data, onSuccess, onError) => {
        apiCall(fetchReport.type, data, onSuccess, onError);
    }
    return {
        createRemainder,
        editReminder,
        removeReminder,
        getReminderReports

    }
}